import { Column } from 'hedron';
import React from 'react';
import PropTypes from 'prop-types';

const DesignerListSectionSubcolumn = ({ children, index }) => (
  <Column key={index} lg={3} divisions={15} fluid>
    {children}
  </Column>
);

DesignerListSectionSubcolumn.propTypes = {
  children: PropTypes.array,
  index: PropTypes.number.isRequired,
};

export default DesignerListSectionSubcolumn;
